import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
// Expose the backend host globally so lightweight fetches (e.g., the MSG91
// debug beacon in Auth.jsx) can hit it without importing this module.
if (typeof window !== "undefined") {
  window.__jx_apiRoot = BACKEND_URL;
}

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("jx_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function apiErr(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}

export const inr = (n) =>
  "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 });

/**
 * Multi-currency helper.
 * Given an INR amount and an INR-based rates map ({USD, EUR, GBP, ...}),
 * returns a compact secondary-line string like  "≈ $15.60 · €14.30 · £12.20".
 * Rates map format: { USD: 0.012, EUR: 0.011, GBP: 0.0094, INR: 1 }.
 * Returns an empty string when rates are missing so callers can render null.
 */
const CURRENCY_META = {
  USD: { symbol: "$" },
  EUR: { symbol: "€" },
  GBP: { symbol: "£" },
  AED: { symbol: "AED " },
};
export function convertInr(inrAmount, code, rates) {
  if (!rates || !rates[code]) return null;
  return Number(inrAmount || 0) * Number(rates[code]);
}
export function fmtCurrency(amount, code) {
  if (amount == null || Number.isNaN(amount)) return "";
  const meta = CURRENCY_META[code] || { symbol: "" };
  const digits = amount < 1000 ? 2 : 0;
  // Force en-US locale everywhere so USD/EUR/GBP share the same decimal & grouping
  return (
    meta.symbol +
    Number(amount).toLocaleString("en-US", {
      maximumFractionDigits: digits,
      minimumFractionDigits: digits,
    })
  );
}
export function multiCurrencyLine(inrAmount, rates, codes = ["USD", "EUR", "GBP"]) {
  if (!rates) return "";
  const parts = codes
    .map((code) => {
      const amt = convertInr(inrAmount, code, rates);
      return amt == null ? null : fmtCurrency(amt, code);
    })
    .filter(Boolean);
  return parts.length ? "≈ " + parts.join(" · ") : "";
}

export const fileSize = (b) => {
  if (!b) return "—";
  if (b > 1048576) return (b / 1048576).toFixed(1) + " MB";
  return (b / 1024).toFixed(0) + " KB";
};

export const METAL_FACTORS = { gold_22k: 17.8, gold_18k: 15.6, gold_14k: 13.4, silver: 10.4 };

export const computeWeights = (cam) => {
  const c = Number(cam);
  if (!c) return {};
  const out = {};
  for (const k in METAL_FACTORS) out[k] = +(c * METAL_FACTORS[k]).toFixed(2);
  return out;
};

export default api;
